import { useEffect } from 'react';

var useDialog = function useDialog(_ref) {
  var dialogRef = _ref.dialogRef,
    isOpen = _ref.isOpen,
    onEscapeCallback = _ref.onEscapeCallback,
    isDisabledEscape = _ref.isDisabledEscape;
  var handleEscape = function handleEscape(event) {
    event.preventDefault();
    if (!isDisabledEscape) {
      onEscapeCallback(event);
    }
  };
  useEffect(function () {
    var _dialogRef$current;
    (_dialogRef$current = dialogRef.current) === null || _dialogRef$current === void 0 || _dialogRef$current.addEventListener('cancel', handleEscape);
    return function () {
      var _dialogRef$current2;
      (_dialogRef$current2 = dialogRef.current) === null || _dialogRef$current2 === void 0 || _dialogRef$current2.removeEventListener('cancel', handleEscape);
    };
  }, [dialogRef, isDisabledEscape, onEscapeCallback]);
  useEffect(function () {
    var dialog = dialogRef.current;
    if (isOpen) {
      dialog === null || dialog === void 0 || dialog.showModal();
    } else {
      dialog === null || dialog === void 0 || dialog.close();
    }
    return function () {
      return dialog === null || dialog === void 0 ? void 0 : dialog.close();
    };
  }, [dialogRef, isOpen]);
  var handleClick = function handleClick(event) {
    if (event.target !== event.currentTarget) {
      return;
    }
    handleEscape(event);
  };
  return {
    handleClick: handleClick
  };
};
var useDialog$1 = useDialog;

export { useDialog$1 as default };
//# sourceMappingURL=useDialog.js.map
